var _defs, _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_10",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.95,10.26H6.05v-2.02c0-.55,.45-1,1-1h9.9c.55,0,1,.45,1,1v2.02Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.95,
    y: 4,
    width: 4.1,
    height: 1.61,
    rx: 0.5,
    ry: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.76,11.88v7.17c0,.53,.47,.95,1.05,.95h8.38c.58,0,1.05-.43,1.05-.95v-7.17H6.76Zm2.57,6.55c0,.19-.16,.35-.35,.35h-.44c-.19,0-.35-.16-.35-.35v-4.98c0-.19,.16-.35,.35-.35h.44c.19,0,.35,.16,.35,.35v4.98Zm3.25,0c0,.19-.16,.35-.35,.35h-.44c-.19,0-.35-.16-.35-.35v-4.98c0-.19,.16-.35,.35-.35h.44c.19,0,.35,.16,.35,.35v4.98Zm3.25,0c0,.19-.16,.35-.35,.35h-.44c-.19,0-.35-.16-.35-.35v-4.98c0-.19,.16-.35,.35-.35h.44c.19,0,.35,.16,.35,.35v4.98Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c61109dd86a86723e0c9f26e35f6f526.svg";
export { ForwardRef as ReactComponent };